import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/api/config';
import { axios } from '@/lib/axios/axios';
import {
  ExtractFnReturnType,
  QueryConfig,
} from '@/lib/react-query/react-query';

const url = `${PREFIX_URL}/legal-center/privacy-policy`;

export type GetPrivacyPolicyResponse = {
  privacyPolicy: {
    content: string;
    createdAt: string;
    id: number;
    type: 'PRIVACY_POLICY';
    version: number;
  } | null;
};

export const privacyPolicyQueryKey = ['privacy-policy'];

export const getPrivacyPolicy = (): Promise<GetPrivacyPolicyResponse> => {
  return axios.get(url);
};
type QueryFnType = typeof getPrivacyPolicy;

type UseGetPrivacyPolicyOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetPrivacyPolicy = ({ config }: UseGetPrivacyPolicyOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: privacyPolicyQueryKey,
    queryFn: getPrivacyPolicy,
    staleTime: Infinity,
    ...config,
  });
};
